import React,{useState, useEffect} from 'react'
import {MDBContainer, MDBBtn} from "mdbreact";
import firebase from "../Config/firebase";

const db = firebase.firestore()

const TestIndex = (props) => {
    // const [isLoaded, setIsLoaded] = useState(false)
    // const [step, setStep] = useState(0)
    // const [allCommunity, setAllCommunity] = useState([])
    //
    // const  getAllCommunity = () => {
    //     db.collection('Community')
    //         .orderBy('createDate', 'desc')
    //         .limit(100)
    //         .get()
    //         .then(docs =>{
    //             let newAllCommunity = []
    //             if(!docs.empty){
    //                 docs.forEach(function (doc)  {
    //                     newAllCommunity.push({
    //                         id: doc.id,
    //                         titleCHI: doc.data().hasOwnProperty('titleCHI') && typeof doc.data().titleCHI !== 'undefined' ? doc.data().titleCHI : '' ,
    //                         title: doc.data().hasOwnProperty('title') && typeof doc.data().titleCHI !== 'undefined' ? doc.data().title : '',
    //                         createDate: doc.data().createDate
    //                     })
    //                 })
    //                 setAllCommunity(newAllCommunity)
    //                 let newStep = step + 1
    //                 setStep(newStep)
    //             }
    //             else{
    //                 setStep(999)
    //             }
    //         })
    // }
    //
    // const getNextCommunity= () => {
    //     db.collection('Community')
    //         .orderBy('createDate', 'desc')
    //         .startAfter(allCommunity[allCommunity.length - 1].createDate)
    //         .limit(100)
    //         .get()
    //         .then(docs =>{
    //             let newAllCommunity = []
    //             if(!docs.empty){
    //                 docs.forEach(function (doc)  {
    //                     newAllCommunity.push({
    //                         id: doc.id,
    //                         titleCHI: doc.data().hasOwnProperty('titleCHI') && typeof doc.data().titleCHI !== 'undefined' ? doc.data().titleCHI : '' ,
    //                         title: doc.data().hasOwnProperty('title') && typeof doc.data().titleCHI !== 'undefined' ? doc.data().title : '',
    //                         createDate: doc.data().createDate
    //                     })
    //                 })
    //                 setAllCommunity(allCommunity.concat(newAllCommunity))
    //                 let newStep = step + 1
    //                 setStep(newStep)
    //                 // console.log(allCommunity)
    //             }
    //             else{
    //                 console.log(allCommunity)
    //                 setStep(999)
    //             }
    //         })
    // }

    return(
        <MDBContainer>
            {/*{*/}
            {/*    step*/}
            {/*}*/}
            {/*<MDBBtn onClick={() => getAllCommunity()}>*/}
            {/*    Start*/}
            {/*</MDBBtn>*/}
            {/*<MDBBtn onClick={() => getNextCommunity()}>*/}
            {/*    Next*/}
            {/*</MDBBtn>*/}
        </MDBContainer>
    )
}
export default TestIndex